<div class="miav3" [class.miav3--chat-aberto]="conversaSelecionada">
  <!-- COLUNA ESQUERDA: lista de conversas -->
  <aside class="miav3-lista">
    <header class="miav3-lista__cabecalho">
      <div class="miav3-lista__titulo">
        <div class="miav3-lista__identidade">
          <h4>Conversas da Mia</h4>
          <span class="miav3-aovivo" [class.miav3-aovivo--on]="aoVivo" title="{{ aoVivo ? 'Atualizando em tempo real' : 'Tempo real desconectado' }}">
            <span class="miav3-aovivo__ponto"></span> {{ aoVivo ? 'ao vivo' : 'offline' }}
          </span>
        </div>
        <button type="button" class="miav3-nova" (click)="novaConversa()" title="Abrir o simulador e começar uma conversa nova com a Mia">
          <i class="fas fa-plus"></i> Nova conversa
        </button>
      </div>

      <div class="miav3-busca">
        <i class="fas fa-search"></i>
        <input type="text" placeholder="Buscar por nome ou telefone…" aria-label="Buscar conversa"
               [(ngModel)]="busca" (ngModelChange)="aoDigitarBusca()" />
      </div>

      <div class="miav3-filtros" role="tablist" aria-label="Filtrar conversas">
        <button type="button" role="tab" [attr.aria-selected]="filtro === 'todas'"
                [class.miav3-filtros__item--ativo]="filtro === 'todas'" (click)="altereFiltro('todas')">
          Todas
        </button>
        <button type="button" role="tab" class="miav3-filtros__fila" [attr.aria-selected]="filtro === 'atendente'"
                [class.miav3-filtros__item--ativo]="filtro === 'atendente'" (click)="altereFiltro('atendente')">
          <span class="miav3-filtros__sinal"></span>
          Em atendimento
          <span class="miav3-filtros__contagem" *ngIf="quantidadeComAtendente > 0">{{ quantidadeComAtendente }}</span>
        </button>
        <button type="button" role="tab" [attr.aria-selected]="filtro === 'nao_converteu'"
                [class.miav3-filtros__item--ativo]="filtro === 'nao_converteu'" (click)="altereFiltro('nao_converteu')">
          Não converteram
          <span class="miav3-filtros__contagem" *ngIf="quantidadeNaoConverteram > 0">{{ quantidadeNaoConverteram }}</span>
        </button>
        <button type="button" role="tab" [attr.aria-selected]="filtro === 'venderam'"
                [class.miav3-filtros__item--ativo]="filtro === 'venderam'" (click)="altereFiltro('venderam')">
          Venderam
        </button>
      </div>

      <!-- Período (última atividade). A fila de atendimento ignora a data. -->
      <div class="miav3-periodo" *ngIf="filtro !== 'atendente'">
        <span class="miav3-periodo__rotulo" title="Período da última atividade das conversas">
          <i class="fas fa-calendar-alt"></i>
        </span>
        <div class="miav3-periodo__grupo" role="group" aria-label="Período da lista">
          <button type="button" *ngFor="let opcao of [{dias: 1, rotulo: 'Hoje'}, {dias: 7, rotulo: '7 dias'}, {dias: 30, rotulo: '30 dias'}]"
                  class="miav3-periodo__chip"
                  [class.miav3-periodo__chip--ativo]="!periodoPersonalizado && periodoDias === opcao.dias"
                  (click)="selecionePeriodo(opcao.dias)">
            {{ opcao.rotulo }}
          </button>
          <button type="button" class="miav3-periodo__chip"
                  [class.miav3-periodo__chip--ativo]="periodoPersonalizado"
                  (click)="ativePeriodoPersonalizado()" title="Escolher as datas de início e fim">
            Outro
          </button>
        </div>
      </div>

      <div class="miav3-periodo__datas" *ngIf="periodoPersonalizado && filtro !== 'atendente'">
        <input type="date" [(ngModel)]="periodoDe" [max]="periodoAte || null" aria-label="Data inicial">
        <span class="miav3-periodo__ate">até</span>
        <input type="date" [(ngModel)]="periodoAte" [min]="periodoDe || null" aria-label="Data final">
        <button type="button" class="miav3-periodo__aplicar"
                [disabled]="!periodoValido" (click)="apliquePeriodo()">Aplicar</button>
      </div>
    </header>

    <div class="miav3-lista__corpo">
      <!-- skeleton de carregamento -->
      <ng-container *ngIf="carregandoLista">
        <div class="miav3-skeleton" *ngFor="let i of [1,2,3,4,5]">
          <div class="miav3-skeleton__avatar"></div>
          <div class="miav3-skeleton__linhas">
            <div class="miav3-skeleton__linha" style="width: 60%"></div>
            <div class="miav3-skeleton__linha" style="width: 85%"></div>
          </div>
        </div>
      </ng-container>

      <!-- vazio -->
      <div class="miav3-vazio" *ngIf="!carregandoLista && conversasVisiveis.length === 0">
        <div class="miav3-vazio__icone">
          <i class="fas" [class.fa-robot]="filtro === 'todas'"
             [class.fa-check]="filtro === 'atendente' || filtro === 'nao_converteu'"
             [class.fa-shopping-bag]="filtro === 'venderam'"></i>
        </div>
        <h5 *ngIf="filtro === 'todas'">Nenhuma conversa no período</h5>
        <h5 *ngIf="filtro === 'atendente'">Fila de atendimento vazia</h5>
        <h5 *ngIf="filtro === 'nao_converteu'">Nenhuma venda perdida por aqui</h5>
        <h5 *ngIf="filtro === 'venderam'">Nenhuma venda no período</h5>
        <p *ngIf="!busca && filtro === 'todas'">Quando a Mia atender um cliente no WhatsApp,<br>a conversa aparece aqui em tempo real.</p>
        <p *ngIf="!busca && filtro === 'atendente'">Nenhum cliente está aguardando atendimento humano agora.</p>
        <p *ngIf="!busca && filtro === 'nao_converteu'">Quem quis comprar no período, comprou.</p>
        <p *ngIf="!busca && filtro === 'venderam'">As conversas que fecharem pedido aparecem aqui.</p>
        <p *ngIf="busca">Nada encontrado para “{{ busca }}”.</p>
      </div>

      <!-- itens -->
      <button type="button" class="miav3-conversa"
              *ngFor="let conversa of conversasVisiveis; trackBy: rastreieConversa"
              [class.miav3-conversa--ativa]="conversa.id === conversaSelecionada?.id"
              [class.miav3-conversa--atendente]="conversa.estado === 'PAUSADA_ATENDENTE'"
              (click)="abraConversa(conversa)">
        <div class="miav3-avatar" [style.background]="corAvatar(conversa)">{{ iniciais(conversa) }}</div>
        <div class="miav3-conversa__info">
          <div class="miav3-conversa__topo">
            <span class="miav3-conversa__nome">{{ nomeExibicao(conversa) }}</span>
            <span class="miav3-conversa__hora">{{ horaRelativa(conversa.atualizadaEm) }}</span>
          </div>
          <div class="miav3-conversa__baixo">
            <span class="miav3-conversa__preview">{{ previewMensagem(conversa) }}</span>
            <span class="miav3-chip miav3-chip--custo" *ngIf="ehAdmin && conversa.custoTotal > 0"
                  [title]="tituloCustoEmReais()">{{ custoEmReaisFormatado(conversa.custoTotal) }}</span>
            <span class="miav3-chip miav3-chip--venda" *ngIf="conversa.pedidosGerados > 0"
                  [title]="tituloVendas(conversa)">
              <i class="fas fa-shopping-bag"></i> {{ rotuloVendas(conversa) }}
            </span>
            <span class="miav3-chip miav3-chip--pausada" *ngIf="conversa.estado === 'PAUSADA_ATENDENTE'">
              <span class="miav3-chip__ponto"></span> atendente
            </span>
            <span class="miav3-chip miav3-chip--motivo" *ngIf="etiquetaMotivo(conversa) as motivo">
              {{ motivo }}
            </span>
          </div>
        </div>
      </button>
    </div>
  </aside>

  <!-- COLUNA DIREITA: transcrição -->
  <section class="miav3-chat">
    <!-- nenhuma conversa selecionada -->
    <div class="miav3-chat__vazio" *ngIf="!conversaSelecionada">
      <div class="miav3-chat__vazio-arte">
        <i class="fas fa-comments"></i>
      </div>
      <h4>Acompanhe a Mia trabalhando</h4>
      <p>Selecione uma conversa ao lado para ver a transcrição completa —<br>ela atualiza sozinha conforme o cliente e a Mia conversam.</p>
    </div>

    <ng-container *ngIf="conversaSelecionada">
      <header class="miav3-chat__cabecalho">
        <button type="button" class="miav3-chat__voltar" (click)="fecheConversa()" aria-label="Voltar para as conversas">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="miav3-avatar miav3-avatar--grande" [style.background]="corAvatar(conversaSelecionada)">
          {{ iniciais(conversaSelecionada) }}
        </div>
        <div class="miav3-chat__contato">
          <a [routerLink]="['/admin/contatos', telefoneDoContato(conversaSelecionada.telefone)]"><strong>{{ nomeExibicao(conversaSelecionada) }}</strong></a>
          <small class="miav3-chat__resumo">
            {{ formateTelefone(conversaSelecionada.telefone) }} · {{ conversaSelecionada.totalTurnos }} mensagens
          </small>
          <div class="miav3-chat__telemetria" *ngIf="ehAdmin && (resumoTelemetria || conversaSelecionada.custoTotal > 0)">
            <span *ngIf="resumoTelemetria?.modelos?.length" title="Modelo(s) de IA usado(s) nesta conversa">
              <i class="fas fa-microchip"></i> {{ modelosDaConversa() }}
            </span>
            <span *ngIf="resumoTelemetria"
                  [title]="'Tokens somados da conversa: ' + resumoTelemetria.entrada + ' de entrada, ' + resumoTelemetria.saida + ' de saída, ' + resumoTelemetria.cacheEscrita + ' gravados no cache, ' + resumoTelemetria.cache + ' lidos do cache'">
              {{ formateTokens(resumoTelemetria.entrada) }}→{{ formateTokens(resumoTelemetria.saida) }} tokens
            </span>
            <span *ngIf="conversaSelecionada.custoTotal > 0" [title]="tituloCustoEmReais()">
              <i class="fas fa-bolt"></i> {{ custoEmReaisFormatado(conversaSelecionada.custoTotal) }}
            </span>
            <span *ngIf="custoMedioPorTurno()" [title]="tituloCustoMedio()">
              {{ custoMedioPorTurno() }}
            </span>
            <span *ngIf="cacheHitDaConversa() !== null"
                  title="% dos tokens de entrada servidos pelo cache (gravação conta como preço cheio)">
              <i class="fas fa-database"></i> cache {{ cacheHitDaConversa() }}%
            </span>
            <span *ngIf="turnosSemIA()" title="Turnos da Mia resolvidos por atalho determinístico, sem chamar o modelo">
              <i class="fas fa-route"></i> {{ turnosSemIA() }}
            </span>
          </div>
        </div>
        <div class="miav3-chat__acoes">
          <span class="miav3-chip miav3-chip--bloqueada" *ngIf="contatoBloqueado()">
            <i class="fas fa-ban"></i> Mia desativada
          </span>
          <span class="miav3-chip miav3-chip--mia"
                *ngIf="!contatoBloqueado() && conversaSelecionada.estado === 'ATIVA'">
            <i class="fas fa-robot"></i> Mia ativa
          </span>
          <span class="miav3-chip miav3-chip--pausada"
                *ngIf="!contatoBloqueado() && conversaSelecionada.estado === 'PAUSADA_ATENDENTE'">
            <i class="fas fa-headset"></i> Com atendente
          </span>
          <button type="button" class="miav3-acao-atendimento miav3-acao-atendimento--assumir"
                  *ngIf="!contatoBloqueado() && conversaSelecionada.estado === 'ATIVA'"
                  [disabled]="alterandoEstado" (click)="assumaConversa()">
            <i class="fas" [class.fa-circle-notch]="alterandoEstado" [class.fa-spin]="alterandoEstado"
               [class.fa-headset]="!alterandoEstado"></i>
            {{ alterandoEstado ? 'Assumindo…' : 'Assumir conversa' }}
          </button>
          <button type="button" class="miav3-acao-atendimento miav3-acao-atendimento--devolver"
                  *ngIf="!contatoBloqueado() && conversaSelecionada.estado === 'PAUSADA_ATENDENTE'"
                  [disabled]="alterandoEstado || enviandoResposta" (click)="devolvaConversa()">
            <i class="fas" [class.fa-circle-notch]="alterandoEstado" [class.fa-spin]="alterandoEstado"
               [class.fa-robot]="!alterandoEstado"></i>
            {{ alterandoEstado ? 'Devolvendo…' : 'Devolver para a Mia' }}
          </button>
          <!-- bloqueio permanente do contato: some quando já bloqueado, porque a
               faixa abaixo do cabeçalho é quem explica e reativa -->
          <button type="button" class="miav3-acao-bloqueio" *ngIf="!contatoBloqueado()"
                  [disabled]="alterandoBloqueio" (click)="alterneBloqueioDoContato(true)"
                  title="Desativar a Mia para este contato — ela para de responder este número até você reativar"
                  aria-label="Desativar a Mia para este contato">
            <i class="fas" [class.fa-circle-notch]="alterandoBloqueio" [class.fa-spin]="alterandoBloqueio"
               [class.fa-ban]="!alterandoBloqueio"></i>
          </button>
          <a [href]="linkWhatsapp(conversaSelecionada)" target="_blank" class="miav3-botao-whatsapp"
             title="Abrir conversa no WhatsApp" aria-label="Abrir conversa no WhatsApp">
            <i class="fab fa-whatsapp"></i>
          </a>
        </div>
      </header>

      <div class="miav3-bloqueio" *ngIf="contatoBloqueado()">
        <i class="fas fa-ban"></i>
        <span>
          <strong>A Mia está desativada para este contato.</strong>
          Ela não responde este número em canal nenhum — as mensagens continuam chegando aqui e você
          responde pelo painel.
        </span>
        <button type="button" [disabled]="alterandoBloqueio" (click)="alterneBloqueioDoContato(false)">
          <i class="fas" [class.fa-circle-notch]="alterandoBloqueio" [class.fa-spin]="alterandoBloqueio"
             [class.fa-robot]="!alterandoBloqueio"></i>
          {{ alterandoBloqueio ? 'Reativando…' : 'Reativar a Mia' }}
        </button>
      </div>

      <div class="miav3-alerta" *ngIf="erroAcao" role="alert">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{ erroAcao }}</span>
        <button type="button" (click)="erroAcao = ''" aria-label="Fechar aviso"><i class="fas fa-times"></i></button>
      </div>

      <div class="miav3-chat__corpo" #corpoChat>
        <div class="miav3-chat__carregando" *ngIf="carregandoChat">
          <i class="fas fa-circle-notch fa-spin"></i> carregando conversa…
        </div>

        <ng-container *ngFor="let item of itensChat; trackBy: rastreieItemChat">
          <!-- separador de dia -->
          <div class="miav3-separador" *ngIf="item.tipo === 'separador'">
            <span>{{ item.label }}</span>
          </div>

          <!-- mensagem de sistema -->
          <div class="miav3-sistema" *ngIf="item.tipo === 'turno' && item.turno.papel === 'sistema'">
            <i class="fas fa-info-circle"></i> {{ item.turno.texto }}
          </div>

          <!-- bolhas -->
          <div class="miav3-bolha-wrapper"
               *ngIf="item.tipo === 'turno' && item.turno.papel !== 'sistema'"
               [class.miav3-bolha-wrapper--direita]="item.turno.papel !== 'cliente'">
            <div class="miav3-bolha"
                 [class.miav3-bolha--cliente]="item.turno.papel === 'cliente'"
                 [class.miav3-bolha--mia]="item.turno.papel === 'mia'"
                 [class.miav3-bolha--atendente]="item.turno.papel === 'atendente'"
                 [class.miav3-bolha--enviando]="item.turno.statusEnvio === 'enviando'"
                 [class.miav3-bolha--aviso]="item.turno.statusEnvio === 'aviso'"
                 [class.miav3-bolha--erro]="item.turno.statusEnvio === 'erro'"
                 [class.miav3-bolha--com-lista]="item.turno.opcoesLista?.length">
              <div class="miav3-bolha__autor" *ngIf="item.turno.papel === 'atendente'">
                <i class="fas fa-headset"></i> Atendente
              </div>
              <!-- rótulo de mensagem encaminhada (context.forwarded da Cloud API), como no WhatsApp -->
              <div class="miav3-bolha__encaminhada" *ngIf="item.turno.papel === 'cliente' && item.turno.encaminhada"
                   title="O cliente encaminhou esta mensagem em vez de digitá-la">
                <i class="fas fa-share"></i> Encaminhada
              </div>

              <!-- imagem recebida do cliente (salva em disco pelo Despachante) — clique abre em tamanho real -->
              <a class="miav3-bolha__imagem" *ngFor="let imagem of item.turno.imagensMidia"
                 [href]="imagem.url" target="_blank" rel="noopener"
                 title="Abrir a imagem em tamanho real">
                <img [src]="imagem.url" [alt]="imagem.legenda || 'Imagem enviada pelo cliente'" loading="lazy"/>
              </a>

              <!-- áudio recebido (recado de voz): player nativo dentro da bolha -->
              <audio class="miav3-audio" *ngFor="let audio of item.turno.audiosMidia"
                     controls preload="none" [src]="audio.url"></audio>

              <!-- documento recebido (PDF etc.): cartão com download, como no WhatsApp -->
              <a class="miav3-documento" *ngFor="let documento of item.turno.documentosMidia"
                 [href]="documento.urlDownload" [title]="'Baixar ' + documento.nome">
                <span class="miav3-documento__icone"><i class="far" [ngClass]="documento.icone"></i></span>
                <span class="miav3-documento__info">
                  <span class="miav3-documento__nome">{{ documento.nome }}</span>
                  <span class="miav3-documento__tipo">{{ documento.extensao }}</span>
                </span>
                <span class="miav3-documento__baixar"><i class="fas fa-download"></i></span>
              </a>

              <div class="miav3-bolha__texto" [innerHTML]="(item.turno.corpoExibicao || item.turno.texto) | formataWhatsapp"></div>

              <!-- cartão de opções da mensagem de lista (bloco "• opção" da transcrição) -->
              <div class="miav3-opcoes" *ngIf="item.turno.opcoesLista?.length">
                <!-- opções com preço: linhas de menu (título à esquerda, preço à direita) -->
                <div class="miav3-opcoes__menu" *ngIf="item.turno.opcoesComPreco">
                  <div class="miav3-opcoes__linha" *ngFor="let opcao of opcoesVisiveis(item.turno)">
                    <span class="miav3-opcoes__titulo">{{ opcao.titulo }}</span>
                    <span class="miav3-opcoes__preco" *ngIf="opcao.preco">{{ opcao.preco }}</span>
                  </div>
                </div>
                <!-- opções sem preço (categorias): chips em grade -->
                <div class="miav3-opcoes__cartao" *ngIf="!item.turno.opcoesComPreco">
                  <span class="miav3-opcoes__chip" *ngFor="let opcao of opcoesVisiveis(item.turno)">{{ opcao.titulo }}</span>
                </div>
                <button type="button" class="miav3-opcoes__alternar" *ngIf="opcoesColapsaveis(item.turno)"
                        (click)="alterneOpcoes(item.turno)">
                  <i class="fas" [class.fa-chevron-down]="!item.turno.opcoesExpandidas"
                     [class.fa-chevron-up]="item.turno.opcoesExpandidas"></i>
                  {{ item.turno.opcoesExpandidas ? 'Mostrar menos' : 'Ver todas as ' + item.turno.opcoesLista.length + ' opções' }}
                </button>
              </div>
              <div class="miav3-bolha__meta">
                <span class="miav3-bolha__custo" *ngIf="ehAdmin && item.turno.papel === 'mia' && item.turno.modelo"
                      [class.miav3-bolha__custo--clicavel]="item.turno.modelo !== 'atalho-categoria'"
                      [title]="tituloTelemetria(item.turno)" (click)="alterneDetalheCusto(item.turno)">
                  <i class="fas fa-bolt"></i>
                  {{ rotuloModelo(item.turno.modelo) }}<ng-container *ngIf="tokensDoTurno(item.turno)"> · {{ tokensDoTurno(item.turno) }}</ng-container><ng-container *ngIf="cacheDoTurno(item.turno)"> · {{ cacheDoTurno(item.turno) }}</ng-container><ng-container *ngIf="item.turno.custoUsd != null"> · {{ custoEmReaisFormatado(item.turno.custoUsd) }}</ng-container><span class="miav3-bolha__latencia-lenta" *ngIf="latenciaLenta(item.turno)"> · <i class="fas fa-hourglass-half"></i> {{ latenciaFormatada(item.turno.latenciaMs) }}</span>
                </span>
                <span class="miav3-bolha__status miav3-bolha__status--enviando" *ngIf="item.turno.statusEnvio === 'enviando'">
                  <i class="fas fa-circle-notch fa-spin"></i> enviando
                </span>
                <span class="miav3-bolha__status miav3-bolha__status--aviso" *ngIf="item.turno.statusEnvio === 'aviso'">
                  <i class="fas fa-exclamation-triangle"></i> enviada · histórico pendente
                </span>
                <button type="button" class="miav3-bolha__repetir" *ngIf="item.turno.statusEnvio === 'erro'"
                        (click)="tenteNovamente(item.turno)">
                  <i class="fas fa-redo-alt"></i> Tentar novamente
                </button>
                {{ item.turno.criadoEm | date:'HH:mm' }}
                <span class="miav3-ticks" *ngIf="item.turno.papel !== 'cliente' && item.turno.statusWhatsapp"
                      [class.miav3-ticks--lida]="item.turno.statusWhatsapp === 'read'"
                      [class.miav3-ticks--falha]="item.turno.statusWhatsapp === 'failed'"
                      [title]="tituloStatusWhatsapp(item.turno.statusWhatsapp)">
                  <i class="fas"
                     [class.fa-check]="item.turno.statusWhatsapp === 'sent'"
                     [class.fa-check-double]="item.turno.statusWhatsapp === 'delivered' || item.turno.statusWhatsapp === 'read'"
                     [class.fa-exclamation-circle]="item.turno.statusWhatsapp === 'failed'"></i>
                </span>
              </div>

              <!-- quebra do custo do turno (toque no badge ⚡ abre/fecha) -->
              <div class="miav3-custo-detalhe" *ngIf="ehAdmin && item.turno.detalheCustoAberto">
                <ng-container *ngIf="parcelasDoTurno(item.turno) as parcelas; else semQuebra">
                  <div class="miav3-custo-detalhe__linha" *ngFor="let parcela of parcelas">
                    <span class="miav3-custo-detalhe__rotulo">{{ parcela.rotulo }}</span>
                    <span class="miav3-custo-detalhe__conta">{{ formateTokens(parcela.tokens) }} × {{ formatePrecoMtok(parcela.precoMtok) }}</span>
                    <span class="miav3-custo-detalhe__valor">{{ formateUsd(parcela.usd) }} · {{ parcela.pct }}%</span>
                  </div>
                  <div class="miav3-custo-detalhe__linha miav3-custo-detalhe__linha--total">
                    <span class="miav3-custo-detalhe__rotulo">Total</span>
                    <span class="miav3-custo-detalhe__conta" *ngIf="item.turno.latenciaMs != null">latência {{ latenciaFormatada(item.turno.latenciaMs) }}</span>
                    <span class="miav3-custo-detalhe__valor">{{ formateUsd(item.turno.custoUsd) }} · {{ custoEmReaisFormatado(item.turno.custoUsd) }}</span>
                  </div>
                  <div class="miav3-custo-detalhe__nota" *ngIf="custoSemCacheUsd(item.turno) as semCache">
                    Sem cache custaria {{ formateUsd(semCache) }}
                  </div>
                </ng-container>
                <ng-template #semQuebra>
                  <div class="miav3-custo-detalhe__linha miav3-custo-detalhe__linha--total">
                    <span class="miav3-custo-detalhe__rotulo">Total</span>
                    <span class="miav3-custo-detalhe__conta" *ngIf="item.turno.latenciaMs != null">latência {{ latenciaFormatada(item.turno.latenciaMs) }}</span>
                    <span class="miav3-custo-detalhe__valor" *ngIf="item.turno.custoUsd != null">{{ formateUsd(item.turno.custoUsd) }} · {{ custoEmReaisFormatado(item.turno.custoUsd) }}</span>
                  </div>
                  <div class="miav3-custo-detalhe__nota">Turno anterior ao registro de preços — sem quebra por componente.</div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <footer class="miav3-conducao" *ngIf="conversaSelecionada.estado === 'ATIVA'">
        <div class="miav3-conducao__icone"><i class="fas fa-robot"></i></div>
        <div class="miav3-conducao__texto">
          <strong>A Mia está conduzindo esta conversa</strong>
          <span>Você acompanha tudo em tempo real e pode entrar quando precisar.</span>
        </div>
        <button type="button" (click)="assumaConversa()" [disabled]="alterandoEstado"
                [attr.aria-busy]="alterandoEstado">
          <i class="fas" [class.fa-circle-notch]="alterandoEstado" [class.fa-spin]="alterandoEstado"
             [class.fa-headset]="!alterandoEstado"></i>
          {{ alterandoEstado ? 'Assumindo…' : 'Assumir agora' }}
        </button>
      </footer>

      <footer class="miav3-compositor" *ngIf="conversaSelecionada.estado === 'PAUSADA_ATENDENTE'">
        <div class="miav3-compositor__fora-janela" *ngIf="!carregandoChat && !dentroDaJanela24h()">
          <span class="miav3-compositor__fora-icone"><i class="fas fa-lock"></i></span>
          <span>
            <strong>Fora da janela de 24h</strong>
            Só é possível iniciar uma nova conversa com template.
          </span>
        </div>

        <div class="miav3-respostas-rapidas" *ngIf="dentroDaJanela24h()" aria-label="Respostas rápidas">
          <span class="miav3-respostas-rapidas__rotulo"><i class="fas fa-bolt"></i> Respostas rápidas</span>
          <button type="button" *ngFor="let rapida of respostasRapidas" (click)="useRespostaRapida(rapida.texto)">
            {{ rapida.rotulo }}
          </button>
        </div>

        <div class="miav3-compositor__linha">
          <div class="miav3-compositor__campo">
            <textarea #campoResposta rows="1" maxlength="4096"
                      [placeholder]="dentroDaJanela24h() ? 'Digite sua resposta…' : 'Envio indisponível fora da janela de 24h'"
                      aria-label="Resposta para o cliente"
                      [(ngModel)]="resposta"
                      [disabled]="carregandoChat || !dentroDaJanela24h() || enviandoResposta"
                      (keydown)="aoPressionarResposta($event)"
                      (input)="aoDigitarResposta($event)"></textarea>
          </div>
          <button type="button" class="miav3-compositor__enviar"
                  [disabled]="!resposta.trim() || !dentroDaJanela24h() || enviandoResposta"
                  (click)="envieResposta()" aria-label="Enviar resposta">
            <i class="fas" [class.fa-paper-plane]="!enviandoResposta"
               [class.fa-circle-notch]="enviandoResposta" [class.fa-spin]="enviandoResposta"></i>
          </button>
        </div>

        <div class="miav3-compositor__rodape">
          <span [class.miav3-compositor__janela--fechada]="!dentroDaJanela24h()">
            <i class="fas" [class.fa-shield-alt]="dentroDaJanela24h()" [class.fa-clock]="!dentroDaJanela24h()"></i>
            {{ carregandoChat ? 'Verificando janela…' : textoDaJanela() }}
          </span>
          <span class="miav3-compositor__atalho"><kbd>Enter</kbd> envia · <kbd>Shift</kbd> + <kbd>Enter</kbd> quebra a linha</span>
        </div>
      </footer>
    </ng-container>
  </section>
</div>
